const styles = (color, indicatorColor) => ({
  tabLabel: {
    fontFamily: "DM Sans",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    textAlign: "center",
    textTransform: "capitalize",
    padding: "6px 8px",
    minWidth: "auto",
    minHeight: "auto",
    "&.Mui-selected": {
      color: color,
    },
  },
  tabContainer: {
    backgroundColor: indicatorColor,
  },
});

export default styles;
